(() => {
  const getBadge = (target) => target.closest?.('.ts-information-badge');
  const isTrigger = (target) => target.closest?.('.ts-information-badge__trigger');

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType && event.pointerType !== 'mouse') return;
    const trigger = isTrigger(event.target);
    if (!trigger) return;
    const badge = getBadge(trigger);
    if (badge) badge.open = true;
  });

  document.addEventListener('pointerout', (event) => {
    if (event.pointerType && event.pointerType !== 'mouse') return;
    const trigger = isTrigger(event.target);
    if (!trigger) return;
    const badge = getBadge(trigger);
    if (badge) badge.open = false;
  });
})();
